export default "__VITE_ASSET__BX2$n9AH__"